module.exports = __webpack_public_path__ + "img/jo1.f2349d0a.png";